<template>
  <!-- Request Modal -->
  <div class="modal custom-modal fade payment-modal" id="add-payment" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">Add Payment to Wallet</h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <div class="wallet-wrap wallet-modal">
            <div class="wallet-amt">
              <h5>Your Wallet Balance</h5>
              <h2>$4,544</h2>
            </div>
          </div>
          <form>
            <div class="input-space">
              <label class="form-label">Amount</label>
              <input type="text" class="form-control" placeholder="Enter Amount" />
            </div>
            <div class="or-div">
              <h6>OR</h6>
            </div>
            <div class="add-wallet-amount form-check">
              <ul>
                <li
                  v-for="(item, index) in items"
                  :key="index"
                  :class="{ active: item.checked }"
                >
                  <div class="add-wallet-checkbox">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :id="'value' + index"
                      v-model="item.checked"
                      @click="toggleActive(item)"
                    />
                    <label :for="'value' + index">{{ item.label }}</label>
                  </div>
                  <div class="add-wallet-price">
                    <span>+ ${{ item.price }}</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="radio-setview">
              <h6>Select Payment Gateway</h6>
              <div class="radio">
                <div class="form-check form-check-inline mb-3">
                  <input
                    class="form-check-input default-check me-1"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio3"
                    value="Credit Card"
                  />
                  <label class="form-check-label" for="inlineRadio3">Credit Card</label>
                </div>
                <div class="form-check form-check-inline mb-0">
                  <input
                    class="form-check-input default-check me-1"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio4"
                    value="Paypal"
                    checked
                  />
                  <label class="form-check-label" for="inlineRadio4">Paypal</label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="table-accept-btn">
            <a
              href="javascript:;"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              aria-label="Close"
              >Reset</a
            >
            <a
              href="javascript:;"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              aria-label="Close"
              >Submit</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Request Modal -->

  <!-- Add new Modal -->
  <div class="modal custom-modal fade cancel-modal" id="add-new-card" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">Add New Card</h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <form>
            <div class="row">
              <div class="col-lg-12">
                <div class="input-space">
                  <label class="form-label">Card Number</label>
                  <input
                    type="text"
                    class="form-control"
                    id="CardNumber"
                    placeholder="43576777687998998"
                  />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="input-space">
                  <label class="form-label">Name On Card Number</label>
                  <input type="text" class="form-control" placeholder="Sport" />
                </div>
              </div>
              <div class="col-lg-8">
                <div class="input-space">
                  <label class="form-label">Expiry Date</label>
                  <datepicker
                    v-model="startdate"
                    class="form-control datetimepicker"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
              <div class="col-lg-4">
                <div class="input-space">
                  <label class="form-label">CVV </label>
                  <input type="text" class="form-control" placeholder="099" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-check policy d-flex align-items-center">
                  <div class="d-inline-block">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="policy"
                    />
                  </div>
                  <label class="form-check-label" for="policy"
                    >Save for Next Payment</label
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="table-accept-btn">
            <a href="javascript:;" class="btn btn-secondary">Reset</a>
            <a href="javascript:;" class="btn btn-primary">Submit</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Add new Modal -->
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      items: [
        { label: "Add Value 1", price: 80, checked: true },
        { label: "Add Value 2", price: 60, checked: false },
        { label: "Add Value 3", price: 120, checked: false },
        { label: "Add Value 4", price: 120, checked: false },
      ],
    };
  },
  methods: {
    toggleActive(item) {
      item.checked = !item.checked;
    },
  },
};
</script>
